import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const { t } = useI18n();
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (!offline) return null;
  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500 text-white text-xs font-medium shadow-lg" data-testid="offline-banner">
      <WifiOff size={12} /> {t("offline.badge")}
    </div>
  );
}
